
import {
  Vue,
  Component,
  Prop,
  Mixins,
  Watch,
} from 'vue-property-decorator';
import {
  Dialog,
  Pagination,
} from 'element-ui';
import api from '@/api/match';
import eTableMixin from './eTableMixin';

@Component({
  components: {
    Dialog,
    Pagination,
  },
})
export default class ManageBusModal extends Mixins(eTableMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '',
  }) title!: string;

  @Prop({
    required: false,
  }) data!: any;

  mounted() {
    if (this.title.includes('员工')) {
      this.column = [{
        label: '所属机构',
        prop: 'oName',
        align: 'center',
      }, {
        label: '员工姓名',
        prop: 'empName',
        align: 'center',
        width: '150px',
        tooltip: true,
      }, {
        label: '学习平台登录名',
        prop: 'loginName',
        align: 'center',
        width: '150px',
        tooltip: true,
      }, {
        label: '门店登录名',
        prop: 'oLoginName',
        align: 'center',
        tooltip: true,
      }, {
        label: '角色名',
        prop: 'roleName',
        align: 'center',
        width: '150px',
        tooltip: true,
      }];
      this.mList = this.data;
    } else {
      this.column = [{
        label: '分组名称',
        prop: 'groupName',
        align: 'center',
      }, {
        label: '客户姓名',
        prop: 'realName',
        align: 'center',
        width: '150px',
        tooltip: true,
      }, {
        label: '学习平台账号',
        prop: 'userName',
        align: 'center',
        width: '150px',
        tooltip: true,
      }, {
        label: '手机号',
        prop: 'phone',
        align: 'center',
        width: '150px',
        tooltip: true,
      }];
      this.mList = this.data.content;
      this.total = this.data.totalElements;
    }
  }

  reset() {
    this.mList = [];
    this.$emit('update:visible', false);
  }

  getData() {
    api.getUSer(this.data.pid, this.page).then((res: any) => {
      this.mList = res.content;
      this.total = res.totalElements;
    });
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
